import React from "react";
import PropTypes from "prop-types";
import { useState } from "react";
import GenericModal from "./generic-modal.component";
import "react-day-picker/dist/style.css";
import { updateScheduleRequest } from "../../api/wordpress";

const defaultErrorObject = {
  status: false,
  message: "",
};

export default function ChangeScheduleStepModal({
  property,
  closeModal,
  status,
  step,
  state,
  action,
}) {
  const [loading, setLoading] = useState(false);
  const [errorObj, setErrorObj] = useState(defaultErrorObject);

  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const email = JSON.parse(localStorage.getItem("user"))?.user?.user_email;

  const updateSchedule = async () => {
    try {
      setLoading(true);
      const transactionFormData = new FormData();

      transactionFormData.append("id", property.id);
      if (step != null) {
        transactionFormData.append("schedule_step", step);
      }
      if (status != null) {
        transactionFormData.append("schedule_status", status);
      }
      transactionFormData.append("user_email", email);

      await updateScheduleRequest(token, transactionFormData);
      action();
      setLoading(false);
      closeModal();
    } catch (error) {
      setLoading(false);
      const err = error.response ? error.response.data : null;

      setErrorObj({
        message: err != null ? err.message : "Something went wrong",
        status: true,
      });
    }
  };

  return (
    <GenericModal
      onClick={() => {
        //closeModal();
      }}
      modalState={state}
    >
      <div className="bg-white justify-center items-center text-center">
        <div className="flex flex-col space-y-3 items-start w-full px-6 py-10">
          <p className="text-[16px]">
            Are you sure you want to tick this as done?
          </p>
          <div className="flex flex-row items-center space-x-3 text-[#959595] text-[12px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <p>This is irreversible</p>
          </div>
          {errorObj.status && (
            <div
              className="flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
              role="alert"
            >
              <svg
                className="inline flex-shrink-0 mr-3 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <div dangerouslySetInnerHTML={{ __html: errorObj.message }} />
            </div>
          )}
        </div>
        <div className="bg-[#E9F2FF] h-[100px] px-6 flex items-center justify-between">
          <button
            type="button"
            onClick={() => closeModal()}
            disabled={loading}
            className="close-modal w-full flex flex-row justify-center items-end rounded-md border shadow-sm px-4 py-2 bg-primary text-base font-medium text-white border-primary hover:bg-transparent hover:text-primary hover:border-primary focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
          >
            <span>No</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <button
            type="button"
            onClick={() => updateSchedule()}
            disabled={loading}
            className="close-modal w-full flex flex-row justify-center items-center rounded-md border shadow-sm px-4 py-2 bg-primary text-base font-medium text-white border-primary hover:bg-transparent hover:text-primary hover:border-primary focus:outline-none focus:right-0  sm:ml-3 sm:w-auto sm:text-sm"
          >
            {loading ? (
              <svg
                role="status"
                className="inline w-4 h-4 mr-3 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
            ) : (
              <>
                <span>Yes</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </GenericModal>
  );
}


ChangeScheduleStepModal.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  closeModal: PropTypes.func.isRequired,
  status: PropTypes.string,
  step: PropTypes.string,
  state: PropTypes.bool.isRequired,
  action: PropTypes.func.isRequired,
};
